import {SelectFilter} from './select-filter';

export class PillSelectFilter extends SelectFilter {
  getTagName(): string {
    return 'pds-gw-pill-select-filter';
  }
}
